import styles from './AuditedFinancials.module.scss';
import DownloadPurple from '../../../../assets/download-purple.svg';
import { useAuditedReportDownload } from './useAuditedReportDownload';

interface AuditedFinancialsProps {
    assesseeOrgId: string;
    companyName?: string;
}

function AuditedFinancials({ assesseeOrgId, companyName = '' }: AuditedFinancialsProps) {
    const { downloading, onDownloadClick } = useAuditedReportDownload({ assesseeOrgId, orgName: companyName });

    return (
        <button
            type="button"
            className={`${styles.DownloadControl}${downloading ? ` ${styles.DownloadControlDisabled}` : ''}`}
            onClick={onDownloadClick}
            disabled={downloading}
            aria-label="Download"
        >
            <img src={DownloadPurple} alt="" width={16} height={16} />
            <span>Download</span>
        </button>
    );
}

export default AuditedFinancials;
